export default "__VITE_ASSET__Dsj3GAUx__"